// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light[data-v-e3b3aaaa]{background-color:#fff}.theme--light[data-v-e3b3aaaa]  a{color:#001b41!important}.theme--dark[data-v-e3b3aaaa]{background-color:#0a121c}.theme--dark[data-v-e3b3aaaa]  a{color:#f6f7f9!important}.oao-statuspage-overall-status[data-v-e3b3aaaa]{font-size:16px!important}", ""]);
// Exports
module.exports = exports;
